export enum Role {
  STAFF = 'staff',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
}
export type AccountStatus = 'pending_approval' | 'active' | 'suspended' | 'deactivated';

export interface EmergencyContact {
  name: string;
  phone: string;
  relationship: string;
}

export interface BankDetails {
  accountName: string;
  accountNumber: string;
  bankName: string;
}

export interface AttendanceConfig {
  monToFriClockInTime: string;
  gracePeriodMinutes: number;
  lateArrivalFee: number;
  extraLateFeePerInterval: number;
  extraLateFeeIntervalMinutes: number;
  clockOutRequired: boolean;
  missedClockOutFee: number;
  missedClockInFee: number;
  lateFeesEnabled: boolean;
  normalSatClockInTime: string;
  lastSatOfMonthClockInTime: string;
  salary: number;
  allowance: number;
  roasterEnabled: boolean;
  effectiveFrom?: string;
  lastModifiedBy?: string;
  lastModifiedAt?: string;
}

export interface UserProfile {
  firstName: string;
  lastName: string;
  middleName?: string;
  profilePhoto?: string;
  department: string;
  jobTitle: string;
  dateOfHire?: string;
  address?: string;
  emergencyContact?: EmergencyContact;
}

export interface User {
  _id: string;
  employeeId: number;
  username: string;
  phoneNumber: string;
  profile: UserProfile;
  role: Role;
  attendanceConfig: AttendanceConfig;
  bankDetails?: BankDetails;
  accountStatus: AccountStatus;
  lastLoginAt?: string;
  createdBy?: string;
  passwordChangedAt?: string;
  passwordResetRequired: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  username: string;
  phoneNumber: string;
  password: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  department: string;
  jobTitle: string;
  dateOfHire?: string;
  address?: string;
  emergencyContact?: EmergencyContact;
  profilePhoto?: string;
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface AuthResponse {
  accessToken: string;
  user: {
    id: string;
    username: string;
    role: Role;
    profile: {
      firstName: string;
      lastName: string;
    };
    passwordResetRequired: boolean;
  };
}
